import { generateLeadEvent } from "../../modules/tracking/AnalyticsEvents";
import { getFromStorage, saveToStorage } from "../../used-vue/api/Storage";

/**
 * Hard coded stuff for some UTM campaigns
 */
 const prefillCustomerLocationDependingOnUtmCampaign = function() {
    if (getFromStorage('postcode', null) !== null) {
        return;
    }

    const urlObject = new URL(window.location.href);
    if (!urlObject.searchParams.has('utm_campaign')) {
        return;
    }
    const utmCampaign = urlObject.searchParams.get('utm_campaign');
    const utmMatches = utmCampaign.match(new RegExp(/^DS-\d+-Experience-Event-(.*)+/i));
    if (utmMatches == null || typeof utmMatches[1] == 'undefined') {
        return;
    }

    const campaignLocationHashMap = {
        "Leicester": {city: 'Leicester', lat: 52.6368778, lng: -1.1397592},
        "Romford": {city: 'Romford', lat: 51.577076, lng: 0.178319},
        "Chingford": {city: 'Chingford', lat: 51.6320667, lng: 0.0073627},
        "West-London": {city: 'Chiswick', lat: 51.4876272, lng: -0.2671732},
        "Manchester": {city: 'Manchester', lat: 53.4807593, lng: -2.2426305},
        "Birmingham-North": {city: 'Birmingham', lat: 52.48624299, lng: -1.890401},
    };

    if (typeof campaignLocationHashMap[utmMatches[1]] == 'undefined') {
        return;
    }

    const campaignLocation = campaignLocationHashMap[utmMatches[1]];

    saveToStorage('postcode', campaignLocation.city)
    customerLat = campaignLocation.lat;
    saveToStorage('lat', campaignLocation.lat);
    customerLng = campaignLocation.lng;
    saveToStorage('lng', campaignLocation.lng);
}

export default function(form) {
    const validator = new ContactFormValidator({
        element: form,
    });

    const locationHandler = new CustomerLocationHandler();
    const customerLocationElement = form.querySelector('select[name="location-id"]');
    const eventDateSelectElement = form.querySelector('select[name="misc_3_select"]');
    const eventDateSelectArea = eventDateSelectElement.parentNode.parentNode;
    const eventDateTextElement = form.querySelector('input[name="misc_3_text"]');
    const eventDateTextArea = eventDateTextElement.parentNode;
    const eventDateElement = form.querySelector('input[name="misc_3"]');
    const title = form.parentNode.querySelector('.dealer-event-form__title');

    let offerContentId = 0;
    let dealerEventData = [];
    try {
        offerContentId = form.dataset.id;
        dealerEventData = window.dealerEventData[offerContentId] || '[]';
        dealerEventData = JSON.parse(dealerEventData);
    } catch (error) {
        console.error(error);
        dealerEventData = [];
    }

    prefillCustomerLocationDependingOnUtmCampaign();

    // Only show the dealers that have events
    if (dealerEventData.length > 0) {
        locationHandler.setAdditionalLocationFilterFunction(dealer => {
            let found = false;
            dealerEventData.forEach(dealerEvent => {
                if (found === false && dealerEvent.location_id && dealerEvent.location_id == dealer.id) {
                    found = true;
                }
            });
            return found;
        });

        $(eventDateSelectElement).on('change', function() {
            eventDateElement.value = this.value;
        });

        $(customerLocationElement).on('change', function(event) {
            const selectedDealerId = customerLocationElement.value;
            let events = [];
            dealerEventData.forEach(dealerEvent => {
                if (dealerEvent.location_id && dealerEvent.location_id == selectedDealerId && dealerEvent.event_date) {
                    events.push(dealerEvent);
                }
            });

            if (events.length == 0) {
                eventDateSelectArea.classList.remove('visible');
                eventDateSelectArea.classList.add('hidden');
                eventDateTextArea.classList.add('visible');
                eventDateTextArea.classList.remove('hidden');
                eventDateTextElement.value = 'N/A';
                eventDateElement.value = 0;
                $(eventDateSelectElement).empty();
                $(eventDateSelectElement).append($("<option/>", {
                    value: 0,
                    text: 'N/A',
                    selected: true,
                }));
                $(eventDateSelectElement).addClass('active');
                return;
            }

            // For only 1 event, use the text box instead of the drop down list
            if (events.length == 1) {
                eventDateSelectArea.classList.remove('visible');
                eventDateSelectArea.classList.add('hidden');
                eventDateTextArea.classList.add('visible');
                eventDateTextArea.classList.remove('hidden');
                eventDateTextElement.value = events[0].event_date;
                eventDateElement.value = events[0].id;
                $(eventDateSelectElement).empty();
                $(eventDateSelectElement).append($("<option/>", {
                    value: events[0].id,
                    text: events[0].event_date,
                    selected: true,
                }));
                $(eventDateSelectElement).addClass('active');
                return;
            }

            eventDateSelectArea.classList.add('visible');
            eventDateSelectArea.classList.remove('hidden');
            eventDateTextArea.classList.remove('visible');
            eventDateTextArea.classList.add('hidden');
            eventDateElement.value = events[0].id;
            $(eventDateSelectElement).empty();
            events.forEach(event => {
                $(eventDateSelectElement).append($("<option/>", {
                    value: event.id,
                    text: event.event_date,
                }));
                $(eventDateSelectElement).addClass('active');
            });
        });
    }

    locationHandler.setup(form.getAttribute('id'));

    form.addEventListener('submit', async function(e) {
        e.preventDefault();
        if (!await validator.isValid()) {
            return false;
        }

        const formData = new FormData(form);
        validator.preventInput();

        let formName = form.dataset.formName;
        if (typeof formName == 'undefined') {
            formName = 'New Vehicle Offers - Enquiry';
        }

        $.ajax({
            type: "POST",
            cache: false,
            processData: false,
            contentType: false,
            dataType: 'json',
            url: form.getAttribute('action'),
            data: formData,
            success: function(response) {
                dataLayer.push({
                    'event' : 'trackEvent',
                    'eventCategory' : 'New Vehicle Offer',
                    'eventAction' : formName,
                    'eventLabel' : 'Complete',
                    'eventValue' : 0,
                });

                generateLeadEvent('cms_dealer_event');
                generateLeadEvent('cms_form_event_combined');

                title.style.display = 'none';
                if (typeof response.message !== 'undefined') {
                    form.innerHTML = response.message;
                } else {
                    form.innerHTML = '<h2>Thank you</h2><p class="nice-text">Your details have been sent to ' + response.name + '.</p>';
                }

                validator.allowInput();
            },
            error: function(error) {
                validator.errorResponse(error);
                title.style.display = 'block';
            }
        });

        return false;
    });
}